import { apiClients } from '@app/services/api/clients'
import { getApiClient } from '@app/utils/apiUtils'

export default (country, query) => {
  const client = getApiClient(apiClients, country)
  const url = `1.0/tracking?q=${query}`
  return client.get(url)
}
